var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_950_5279",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_950_5279",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEs0lEQVR4nO1ZSYgcZRSuuO+Kl0zivkVEUTAqY2Csft+r6Rl1PAhpEC8evIkn4yQnaTST6fdqHCRxiUERl0vwIoIeFCYagqgwLgRcgx5MNC4nE5dETVpe/X9NOl1l205Xjz3aH9SlX/3LV29/HQR99NFHH330USCYdYyhMyD5iaH1Hnv2292iktzamgTpRA9ctt7OA8j6Vpqog+QAkdw/MjSxLOgxjAxNLGPScbuj3TVXM0yyzYRGIuhxALLWa2YmI/T2Vw/DeCDocYRhPOCIyL6MMLW9YJGA/+q+/zkivMieoE8E/wuNyGGGzjLJA8y1EpFePjw8dWoYVk8CNiyNShoCuoah20F6qAeJyGGQbGWeXNGus0aRXsakT3dKKGg7CuRgOJy6iiF7/ZpdzJPXt0sgQyjU6wD9xH+QvURyZTvrOiYyPDx1EUi+8+/PlMvTZwcdYtUqPZ0hryZ7kn5LNHVBV4kktk66MyWxcuWW44OCUKlUT5gjA/1wdHTjiV0jwqSamlMRmsjTDLyZATrZFSLMtYsZ8lsSmbxPuIo5iVSFh1WQHgzD2oXFEyF5yh0gW9OSGtDvu0GCUzKQLYUSiSI503WMiTbaDrHzRWSh2Wl6v5lbYUQAucPLZ4MFAiBveq2sLoxIalaWsYMFApOOtzKveRLRdxM510oZGU+usO7SnJOhuwG5234Pw8lLQfoFUVxuCN0fA3EF0GtNFoUy6GSPnGWRMCrJSLqvlTM+er1dGJE5p27yj0rlxWMtr4B0h10KkHut5LBsnawj/YxJNjvC8ShI/rCay9ZZFge0dsR05ZcwrJ52VH/uE2RxRHyz3+x4USRXOILxjUdI124zbSR7kk6A5KsgqC8BZBNI35g7j/Qx+wjubHmeSV5q3Ns06KPkgcKIpP18c7YFdMh+t7Il9wMgvtrkRLVrQPIll/SeVEZUu8mbq+WnHyKSO/OJ6MEiiexy9rph6dGHxQOJKflLWMkCyHONvsSQT5n0BXuvccRUrVaPAfQbkzH019HRjWc07p2alpl1YUTMB/ymQ5l1pE8mGiPZzNC3rKBsnMTYIM3vvT2zL2STr3pfbpZF3tkt0PxDIrLPBHmDOUCfcGYg92W3rC9hlrssTJpPlMsPn9cotTID0HV5H8EaLyeTG3LOXOPD7+MZkpEubzUOmvFfYDznwFt8HtkWLHxCvDkr03VpBZ5ZaOPHNErYJM9Yp7LBwemTQfqz2XkakbqJ0OWgQ3amOf3cHSNdnmjQ5az8kWmTPbcq5DKqLhrs/G1+Q+wmzcykITfn+d0ysyMe396tMp47+Vvh7wDoQz6270yzsOWGrpAheTDoFqwdBeSDNGSGYfW4ova2ZMuQ1zyR2SLb6FxYeAXJ1z6vvDI2Vj2l0z2t32HS170m9oShnBssBGwclJJhko9Sn5kPkmKT5HOvid3tjoMKQxTJ+SB9Pw0ADH2GKL6k3fVJMiR9dm5AR/JeczJdMCQjnKTCdXHdTRx1R9IUca0ETJ9jOcjs3+o095usdSWPCxA+b63vuk+0rZ2kjHFlTjsPSH60nPSvaaEVkgoAcYVJH2XIO+a41jAlD8ke6/aSvgSy2t5tuVkfweLGn/k4SvdQ3GY5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/CVV.a0b4cc7cc4ab9074cb6091e4e4b0f71a.svg";
export { ForwardRef as ReactComponent };